import React from 'react'

const PoweredBy = () => {
    return (
        <div style={{
            position: 'fixed',
            bottom: '10px',
            left: '32px',
            zIndex: 1000
        }}>
            <div style={{
                zIndex: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '2px 10px 2px 10px'
            }}>
                <div>
                    <span style={{
                        fontSize: '13px',
                        color: '#f5ffef',
                        fontWeight: '500'
                    }}>
                        <i>Powered by</i>
                    </span>
                </div>
                <div>
                    <img
                        src={require('../../assets/img/logo2.png')}
                        alt="Chemcoolx"
                        style={{ height: '14px' }}
                    />
                </div>
            </div>
        </div>
    )
}

export default PoweredBy